









































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
  },
  data() {
    return {
      creating: false,
      pushing: false,
      importedSubject: null,
    };
  },
  computed: {
    ...mapState({
      boardSection: (state: any) => state.boardSections.board_section,
      boards: (state: any) => state.boards.boards,
      board: (state: any) => state.boards.board,
      subjects: (state: any) => state.descomplica.subjects,
    }),
    ...mapGetters({
      boardByBoardId: 'boardByBoardId',
    }),
  },
  watch: {
    importedSubject: function(newSubject, oldSubject) {
      if (newSubject) {
        this.boardSection.title = newSubject.name;
        this.boardSection.descomplicaSubjectSlug = newSubject.slug;
        this.boardSection.boardByBoardId = this.board;
      } else {
        this.boardSection.title = null;
        this.boardSection.descomplicaSubjectSlug = null;
        this.boardSection.boardByBoardId = { id: null };
      }
    },
  },
  async created() {
    this.creating = this.$route.name === 'board_section_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_BOARD_SECTION');
      await this.$store.dispatch(
        'PULL_SUBJECTS',
        this.board.descomplicaDisciplineSlug,
      );
    } else {
      let boardSectionId = parseInt(this.$route.params.boardSectionId);
      await this.$store.dispatch('PULL_BOARD_SECTION', boardSectionId);
      await this.$store.dispatch(
        'PULL_SUBJECTS',
        this.boardSection.boardByBoardId.descomplicaDisciplineSlug,
      );
    }
  },
  methods: {
    push: async function() {
      if (this.pushing === false) {
        this.pushing = true;
        await this.$store.dispatch('PUSH_BOARD_SECTION', this.boardSection);
        this.pushing = false;
        this.$router.go(-1);
      }
    },
    updateBoard: async function(boardId: number) {
      await this.$store.dispatch('PULL_BOARD', boardId);
      await this.$store.dispatch(
        'PULL_SUBJECTS',
        this.board.descomplicaDisciplineSlug,
      );
      this.boardSection.boardByBoardId = this.board;
      this.boardSection.descomplicaSubjectSlug = null;
    },
  },
});
